module.exports = __webpack_public_path__ + "img/16.a0b20279.png";